var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat',{attrs:{"desfase":0,"momento":1,"finalizado":"","limitar-mensajes":false,"tipo":2,"user":_vm.detalle.id_pedido,"fecha-finalizado":_vm.detalle.fecha_finalizado_chat_cliente}})}
var staticRenderFns = []

export { render, staticRenderFns }